import { initDateTimePicker, getDateTimePicker } from '../core/date-picker.js';

/**
 * Shared date-range picker wiring used by history, lost-sales,
 * stock-notifications, and returns views.
 *
 * Expects #StartDate / #EndDate wrappers, #StartDateText / #EndDateText
 * inputs, #date-range-search form, and #date-range-reset button in the DOM.
 *
 * @param {object}  [options]
 * @param {object}  [options.table]   DataTable instance — if provided, the
 *                                    search form and reset button will trigger
 *                                    table.ajax.reload().
 * @param {string}  [options.format]  Moment format string (default 'MM/DD/YYYY').
 */
export function initDateRangeFilter(options) {
  options = options || {};
  var format = options.format || 'MM/DD/YYYY';
  var table = options.table || null;

  var resetButton = $('#date-range-reset');
  var $startDate = $('#StartDate');
  var $endDate = $('#EndDate');

  var pickerConfig = {
    icons: {
      time: 'fa fa-clock-o',
      date: 'fa fa-calendar',
      up: 'fa fa-arrow-up',
      down: 'fa fa-arrow-down',
    },
    format: format,
    widgetPositioning: {
      horizontal: 'auto',
      vertical: 'bottom',
    },
  };

  initDateTimePicker($startDate, pickerConfig);
  initDateTimePicker($endDate, pickerConfig);

  $startDate.on('dp.change', function (e) {
    var endDatePicker = getDateTimePicker($endDate);
    if (endDatePicker) {
      endDatePicker.minDate(e.date);
    }
    resetButton.show();
  });

  $endDate.on('dp.change', function (e) {
    var startDatePicker = getDateTimePicker($startDate);
    if (startDatePicker) {
      startDatePicker.maxDate(e.date);
    }
    resetButton.show();
  });

  $('#StartDateText').focus(function () {
    var startDatePicker = getDateTimePicker($startDate);
    if (startDatePicker) {
      startDatePicker.show();
    }
  });

  $('#EndDateText').focus(function () {
    var endDatePicker = getDateTimePicker($endDate);
    if (endDatePicker) {
      endDatePicker.show();
    }
  });

  if (table) {
    $('#date-range-search').submit(function (e) {
      e.preventDefault();
      table.ajax.reload();
    });
  }

  $('#date-range-reset').click(function (e) {
    e.preventDefault();
    $('#date-range-search input').not('input[type="submit"]').val('');
    resetButton.hide();
    if (table) {
      table.ajax.reload();
    }
  });
}
